<div *ngIf="isCardViewVisible"
     class="mb-checkout-billing-information" data-cy="mb-checkout-billing-information">
  <div class="mb-checkout-billing-card-view" data-cy="mb-checkout-billing-address-selection">
    <form [formGroup]="billingInformationForm">
      <div *ngIf="isPurchaseCheckoutType"
           class="mb-3 mb-billing-payment-section">
        <div class="row no-gutters mb-2 text-left mb-checkout-headline"
             data-cy="mb-billing-payment-section">
          <span>{{ 'address.purchasePaymentHeadline' | cxTranslate }}</span>
        </div>

        <div *ngIf="paymentModes$ | async as paymentModes" class="row"
             data-cy="mb-checkout-billing-payment-list">
          <div class="col-12 col-md-6" *ngFor="let paymentMode of paymentModes">
            <mb-checkout-billing-common-payment-tile
              [isSelectedPayment]="selectedPaymentModeSelection?.paymentMode?.code === paymentMode?.code"
              [paymentMode]="paymentMode"
              (paymentModeSelected)="paymentModeSelectedHandler($event)"
              [formRegion]="checkoutRegion">
            </mb-checkout-billing-common-payment-tile>
          </div>

          <div class="col-12 col-md-10 mr-md-5">
            <mb-checkout-billing-common-payment-info-tile
              [paymentMode]="selectedPaymentModeSelection?.paymentMode"
              [poNumber]="selectedPaymentModeSelection?.poNumber"
              [formRegion]="checkoutRegion"
              (paymentModeSelected)="paymentModeSelectedHandler($event)">
            </mb-checkout-billing-common-payment-info-tile>
          </div>
        </div>
      </div>

      <div class="mt-2 mb-3 mb-billing-address-section">
        <div class="row no-gutters mb-2 text-left mb-checkout-headline"
             data-cy=" mb-billing-address-section">
          <div *ngIf="isPurchaseCheckoutType">{{ 'address.purchaseBillingAddressHeadline' | cxTranslate }}</div>
          <div *ngIf="!isPurchaseCheckoutType">{{ 'address.requestBillingAddressHeadline1' | cxTranslate }}
            <div
              class="mb-checkout-sub-headline my-3">{{ 'address.requestBillingAddressHeadline2' | cxTranslate }}</div>
          </div>
        </div>

        <div class="row"
             data-cy="mb-checkout-billing-address-list">
          <ng-container *ngIf="addresses$ | async as addresses">
            <div class="col-12 col-md-6" *ngFor="let address of addresses">
              <mb-address-tile [address]="address"
                                [isSelectedAddress]="selectedAddress?.id === address?.id"
                                [formRegion]="checkoutRegion"
                                [showSelectionRadiobox]="address?.verificationStatus !== constants.ADDRESS_VERIFIED_REJECTED_STATUS_04"
                                (addressSelected)="addressSelectedHandler($event)">
              </mb-address-tile>
            </div>
          </ng-container>
          <div class="col-12 col-md-6">
            <mb-checkout-new-address-tile (addNewAddress)="addNewAddressHandler()">
            </mb-checkout-new-address-tile>
          </div>
        </div>
      </div>


      <div class="row no-gutters mt-4">
        <div class="col-12 col-md mr-4 mt-2 order-2 order-md-1">
          <button class="btn btn-block btn-secondary mb-buttons"
                  data-cy="mb-checkout-billing-address-back-btn"
                  type="button"
                  (click)="back()">
            {{ 'navigationPage.backBtn' | cxTranslate }}
          </button>
        </div>
        <div class="col-12 col-md mt-2 order-1 order-md-2">
          <button data-cy="mb-checkout-billing-address-next-btn"
                  class="btn btn-block btn-primary mb-buttons"
                  type="button"
                  mbOneClickAllowed
                  (click)="next()">
            {{ 'navigationPage.nextBtn' | cxTranslate }}
          </button>
        </div>
      </div>
    </form>
  </div>

</div>
